import { NumberKMPipe } from './../../../../../pipes/numberKMPipe';
import { Component, OnInit } from '@angular/core';
import { IndicatorsSearchToolbarModel } from '../../../../../models/indicators-search-toolbar-model.model';
import { IndicatorBoxModel } from '../../../../../models/indicator-box.model';
import { LoyaltyChart } from '../../../../../models/loyalty-chart-config.model';
import { QFilterModel } from '../../../../../models/qfilter.model';
import { IndicatorsChartService, IndicatorsService } from '../../../../../services/indicators/indicators.service';
import { AnalyticsService } from '../../../../../services/analytics/analytics.service';
import { CustomerCampaignService } from '../../../../../services/customer/customer-campaign.service';
import { TranslateService } from '@ngx-translate/core';
import { SearchToolbarModelFactoryService } from '../../../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';
import { SearchToolbarDateFunction, SearchToolbarFactoryParameters, SearchToolbarFilterGrouping, SearchToolbarFilterWindow, SearchToolbarSection } from '../../../../../models/search-toolbar-factory-parameters.model';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-promo-overview-products',
  templateUrl: './overview-products.component.html',
  styleUrls: ['./overview-products.component.css']
})
// Pagina 48
export class PromoOverviewProductsComponent implements OnInit {
  show_results = false;

  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
  public indicators: IndicatorBoxModel[] = [];

  public translations = {
    categoryInvestmentTypePromo: 'promo.categoryInvestmentTypePromo',
    categoryDiscountAverage: 'promo.categoryDiscountAverage',
    categoryPromoPressure: 'promo.categoryPromoPressure',
    nomePromo: 'store.nomePromo',
    typePromo: 'store.typePromo',
    startPromo: 'store.startPromo',
    endPromo: 'store.endPromo',
    investmentPromo: 'store.investmentPromo',
    associatedExpensePromo: 'store.associatedExpensePromo',
    averageDiscountPromo: 'store.averageDiscountPromo',
    promotionalPressurePromo: 'store.promotionalPressurePromo',
    numberReceiptsPromo: 'store.numberReceiptsPromo',
    quantityPromo: 'store.quantityPromo',
    adhesionPromo: 'store.adhesionPromo'
  };

  public datatableCategory: Array<any>;
  public storeError = false;
  public selectOneError: string;
  public data: QFilterModel;

  public categoryInvestmentTypePromo: LoyaltyChart;
  public categoryDiscountAverage: LoyaltyChart;
  public categoryPromoPressure: LoyaltyChart;


  constructor(
    private indicatorService: IndicatorsService,
    private chartsService: IndicatorsChartService,
    private svcAnalytics: AnalyticsService,
    private srvCustomerCampaign: CustomerCampaignService,
    private translate: TranslateService,
    private searchModelFactory: SearchToolbarModelFactoryService,
  ) { }

  ngOnInit() {
    this.initCharts();
  }

  initCharts() {

    this.categoryInvestmentTypePromo = new LoyaltyChart('column');
    this.categoryInvestmentTypePromo.options.xAxis = {'type': 'category'};
    this.categoryInvestmentTypePromo.options.legend = {'enabled': false};
    this.categoryInvestmentTypePromo.options.yAxis.labels.formatter = function() {
      return NumberKMPipe.formatDynamic(this.value, '€');
    };
    this.categoryInvestmentTypePromo.options.tooltip = {
      formatter: function() {
        return NumberKMPipe.formatDynamic(this.y, '€');
      }
    };


    this.categoryDiscountAverage = new LoyaltyChart('column');
    this.categoryDiscountAverage.options.xAxis = {'type': 'category'};
    this.categoryDiscountAverage.options.legend = {'enabled': false};
    this.categoryDiscountAverage.options.yAxis.labels.formatter = function() {
      return this.value + '%';
    };
    this.categoryDiscountAverage.options.tooltip = {
      formatter: function() {
        return this.y + '%';
      }
    };


    this.categoryPromoPressure = new LoyaltyChart('column');
    this.categoryPromoPressure.options.xAxis = {'type': 'category'};
    this.categoryPromoPressure.options.legend = {'enabled': false};
    this.categoryPromoPressure.options.yAxis.labels.formatter = function() {
      return this.value + '%';
    };
    this.categoryPromoPressure.options.tooltip = {
      formatter: function() {
        return this.y + '%';
      }
    };

  }

  setChartInstance(chart: LoyaltyChart, chartInstance) {
    chart.instance = chartInstance;
  }


  searchValue(data: QFilterModel) {
    this.data = data;

    this.indicators = [];

    this.indicatorService.indicatorCalculation('promos.Q194', this.data).subscribe(q194 => {

      /*194*/
      this.indicators.push(new IndicatorBoxModel([q194.find(r => r.name === 'investimento')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '€'}));
      /*195*/
      this.indicators.push(new IndicatorBoxModel([q194.find(r => r.name === 'sconto_medio')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '%'}));
      /*196*/
      this.indicators.push(new IndicatorBoxModel([q194.find(r => r.name === 'pressione_promo')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '%'}));
      /*197*/
      this.indicators.push(new IndicatorBoxModel([q194.find(r => r.name === 'sconto_medio_loyalty')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '%'}));

    });

    this.columnChartInit (data, 'promos.Q198', this.categoryInvestmentTypePromo);
    this.columnChartInit (data, 'promos.Q199', this.categoryDiscountAverage);
    this.columnChartInit (data, 'promos.Q200', this.categoryPromoPressure);
    this.tableInit (data);
    this.show_results = true;

  }

  public toogleErrorStoreDialog() {
    this.storeError = !this.storeError;
  }

  public columnChartInit (data, q, chart) {

    Observable.zip (
      this.indicatorService.getChart(q, data, false)
    ).subscribe( ([res]) => {
      let serie0 = res.series[0].serie;
      let serie1 = res.series[1].serie;
      let series: Array<any> = [];

      for (let i = 0; i < serie0.length; i++) {
        series.push ( {name: serie0[i], y: serie1[i]} );
      }

      let h = series.length * 45;
      h = h < 370 ? 370 : h;
      chart.options.chart.height = h;

      if (chart.instance) {
        while (chart.instance.series.length > 0) {
          chart.instance.series[0].remove(true);
        }
      }

      chart.options.series = [{ name: '', colorByPoint: true, data: series }];
      chart.options.chart.height = 370;
      chart.instance.addSeries(series);
      chart.instance.update(chart.options);
      chart.instance.redraw();

    });
  }

  public tableInit (data: QFilterModel) {
    this.indicatorService.getChart('promos.Q201', data).subscribe((resp) => {

      this.datatableCategory = [];
      if (resp.series.length > 0) {
        let serie0  = resp.series[0].serie;
        let serie1  = resp.series[1].serie;
        let serie2  = resp.series[2].serie;
        let serie3  = resp.series[3].serie;
        let serie4  = resp.series[4].serie;
        let serie6  = resp.series[6].serie;
        let serie8  = resp.series[8].serie;
        let serie10 = resp.series[10].serie;
        let serie11 = resp.series[12].serie;
        let serie12 = resp.series[12].serie;
        let serie13 = resp.series[13].serie;
        for (let i = 0; i < serie0.length; i++) {

          this.datatableCategory.push({
            nomePromo:                  serie1[i],
            typePromo:                  serie0[i],
            startPromo:                 serie2[i],
            endPromo:                   serie3[i],
            investmentPromo:            serie4[i],
            associatedExpensePromo:     serie6[i],
            averageDiscountPromo:       serie8[i],
            promotionalPressurePromo:   serie10[i],
            numberReceiptsPromo:        serie11[i],
            quantityPromo:              serie12[i],
            adhesionPromo:              serie13[i]
          });
        }
      }

    });
  }

  convertData (str) {
    return str.split('-').reverse().join('/');
  }

  resetData() {
    this.show_results = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/analytics/promo/overview/overview-products/overview-products.component.ts